import { cn } from "@tokenterminal/core/utils/cn"
import { forwardRef, type HTMLAttributes } from "react"

export const Body = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn("flex flex-col gap-4 tt-modal-body", className)}
        {...props}
      />
    )
  }
)
Body.displayName = "Body"

export const ButtonGroup = (props: HTMLAttributes<HTMLDivElement>) => {
  return <div className="flex gap-2" {...props} />
}

export const Footer = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn("flex items-center tt-modal-footer", className)}
      {...props}
    />
  )
}
